import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import { useEffect } from 'react'
import { Layout } from '@/components/layout/Layout'
import { HomePage } from '@/pages/home-page/HomePage'
import { CategoryPage } from '@/pages/category-page/CategoryPage'
import { CalculatorsOverviewPage } from '@/pages/calculators-overview-page/CalculatorsOverviewPage'
import { PrivacyPage } from '@/pages/privacy-page/PrivacyPage'
import { TermsPage } from '@/pages/terms-page/TermsPage'
import { ContactPage } from '@/pages/contact-page/ContactPage'
import { NotFoundPage } from '@/pages/NotFoundPage'
import { CalculatorShell } from '@/components/calculator/CalculatorShell'
import { calculators, calculatorsBySlug, getCalcUrl } from '@/registry'
import { PREFIXED_LOCALE_PATHS } from '@/i18n/locales'

function CalculatorRoute({ slug }: { slug: string }) {
  const calc = calculatorsBySlug.get(slug)
  if (!calc) return <NotFoundPage />
  return <CalculatorShell calc={calc} allCalculators={calculators} />
}

function ScrollToTop() {
  const { pathname } = useLocation()
  useEffect(() => { window.scrollTo(0, 0) }, [pathname])
  return null
}

function renderRouteBranch(localePrefix?: string) {
  const childRoutes = (
    <>
      <Route index element={<HomePage />} />
      <Route path="calculators" element={<CalculatorsOverviewPage />} />
      <Route path=":category" element={<CategoryPage />} />
      {calculators.map(c => (
        <Route
          key={`${localePrefix || 'en'}-${c.slug}`}
          path={getCalcUrl(c.slug, c.category).slice(1)}
          element={<CalculatorRoute slug={c.slug} />}
        />
      ))}
      <Route path="privacy" element={<PrivacyPage />} />
      <Route path="terms" element={<TermsPage />} />
      <Route path="contact" element={<ContactPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </>
  )

  if (!localePrefix) {
    return <Route element={<Layout />}>{childRoutes}</Route>
  }

  return (
    <Route path={localePrefix.slice(1)} element={<Layout />}>
      {childRoutes}
    </Route>
  )
}

export default function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          {renderRouteBranch()}
          {PREFIXED_LOCALE_PATHS.map(prefix => (
            <Route key={prefix} path={prefix.slice(1)} element={<Layout />}>
              <Route index element={<HomePage />} />
              <Route path="calculators" element={<CalculatorsOverviewPage />} />
              <Route path=":category" element={<CategoryPage />} />
              {calculators.map(c => (
                <Route
                  key={`${prefix}-${c.slug}`}
                  path={getCalcUrl(c.slug, c.category).slice(1)}
                  element={<CalculatorRoute slug={c.slug} />}
                />
              ))}
              <Route path="privacy" element={<PrivacyPage />} />
              <Route path="terms" element={<TermsPage />} />
              <Route path="contact" element={<ContactPage />} />
              <Route path="*" element={<NotFoundPage />} />
            </Route>
          ))}
        </Routes>
      </BrowserRouter>
    </HelmetProvider>
  )
}
